class ImageBlocks {
  constructor(section) {
    this.section = section;
    this.blockTexts = section.querySelectorAll('.image-block-text');
    this.blockImages = section.querySelectorAll('.image-block-image');
    this.activeBackgroundClass = '';
    this.isMobile = window.innerWidth < 1280;
    this.swiper = null;

    // Get the active background class from the first block (which should be active by default)
    if (
      this.blockTexts.length > 0 &&
      this.blockTexts[0].classList.contains('t-active')
    ) {
      const classList = Array.from(this.blockTexts[0].classList);
      // Find the class that follows t-active
      const activeIndex = classList.indexOf('t-active');
      if (activeIndex !== -1 && activeIndex < classList.length - 1) {
        this.activeBackgroundClass = classList[activeIndex + 1];
      }
    }

    this.init();
    this.setupResizeListener();
  }

  init() {
    if (this.isMobile) {
      this.initMobile();
    } else {
      this.initDesktop();
    }
  }

  setupResizeListener() {
    // Handle resize events to switch between mobile and desktop
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 1280;

      // Only reinitialize if we've crossed the breakpoint
      if (wasMobile !== this.isMobile) {
        // Destroy swiper instance if it exists and we're switching to desktop
        if (wasMobile && this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
        this.init();
      }
    });
  }

  initDesktop() {
    // Set up hover and click functionality for desktop
    this.blockTexts.forEach((blockText) => {
      // Handle mouse enter (hover)
      blockText.addEventListener('mouseenter', () => {
        this.activateBlock(blockText);
      });

      // Handle click for touch devices
      blockText.addEventListener('click', () => {
        this.activateBlock(blockText);
      });
    });
  }

  initMobile() {
    // Initialize Swiper for mobile carousel
    const container = this.section.querySelector(
      '.swiper-container-imageblock',
    );
    if (!container) return;

    // Initialize Swiper with proper configuration
    if (typeof Swiper !== 'undefined') {
      this.swiper = new Swiper(container, {
        slidesPerView: 1.2,
        centeredSlides: false,
        spaceBetween: 24,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          // When window width is >= 480px and < 990px
          480: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        speed: 300,
      });
    }
  }

  activateBlock(blockText) {
    // Remove active class and active background color from all blocks
    this.blockTexts.forEach((block) => {
      block.classList.remove('t-active');
      if (this.activeBackgroundClass) {
        block.classList.remove(this.activeBackgroundClass);
      }
    });

    // Hide all images
    this.blockImages.forEach((image) => {
      image.classList.remove('t-active');
    });

    // Add active class to current block
    blockText.classList.add('t-active');

    // Add active background color
    if (this.activeBackgroundClass) {
      blockText.classList.add(this.activeBackgroundClass);
    }

    // Show corresponding image
    const blockId = blockText.getAttribute('data-block-id');
    const correspondingImage = this.section.querySelector(
      `.image-block-image[data-image-id="${blockId}"]`,
    );
    if (correspondingImage) {
      correspondingImage.classList.add('t-active');
    }
  }
}

// Initialize all image blocks sections on the page
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.image-blocks-desktop');
  sections.forEach((section) => {
    new ImageBlocks(section.closest('.t-relative'));
  });
});
